import React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
// components
import { Tab } from '@mui/material'
import { Tabs } from 'components/UI'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import SyncActiveDirectories from 'components/CTAs/SyncActiveDirectories'
import ActiveDirectoriesTable from './components/Table'
import ConnectActiveDirectory from 'components/CTAs/ConnectActiveDirectory'
import ConnectInjuryMaster from 'components/CTAs/ConnectInjuryMaster'
import SyncInjuryMaster from 'components/CTAs/SyncInjuryMaster'
import InjuryMasterTable from './components/InjuryMasterTable'
import InjuryMasterSettingsModal from 'components/Modals/InjuryMasterSettingsModal'
// context
import TableManagementProvider from 'containers/Search/layers/BL'
// views
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const Content = styled.div`
  margin-top: 16px;
  height: calc(100% - 66px);
`

const ACTIVE_DIRECTORY_TAB = 0
const INJURY_MASTER_TAB = 1

const Integrations: React.FC = () => {
  const [tab, setTab] = React.useState(ACTIVE_DIRECTORY_TAB)

  const handleSetTab = (_, value: number) => setTab(value)

  return (
    <>
      <Helmet>
        <title>Skefto - Integrations</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={false}
        CTA={
          tab === ACTIVE_DIRECTORY_TAB ? (
            <>
              <SyncActiveDirectories />
              <ConnectActiveDirectory />
            </>
          ) : (
            <>
              <SyncInjuryMaster />
              <ConnectInjuryMaster />
            </>
          )
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
            <Tab label='Active Directory' />
            <Tab label='Injury Master' />
          </Tabs>
          <Content>
            {tab === ACTIVE_DIRECTORY_TAB && (
              <TableManagementProvider>
                <ActiveDirectoriesTable />
              </TableManagementProvider>
            )}
            {tab === INJURY_MASTER_TAB && (
              <>
                <InjuryMasterTable />
                <InjuryMasterSettingsModal />
              </>
            )}
          </Content>
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default Integrations
